import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Globals } from '../globals/globals';
import { IdleTimeoutService } from '../services/idle-timeout.service';

/**
 * Attaches the JWT issued after OTP validation to every request made to the SmartSurvey API.
 * The backend now rejects all endpoints except /generateOTP and /validateOTP without this token.
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private globals: Globals, private router: Router, private idleTimeout: IdleTimeoutService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isApiRequest = req.url.indexOf(environment.apiUrl) === 0;
    if (!isApiRequest || !this.globals.token) {
      return next.handle(req);
    }

    const authReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${this.globals.token}`)
    });
    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          // Token expired or session invalidated by the server — force re-login.
          this.idleTimeout.stop();
          this.globals.isAuthenticated = false;
          this.globals.isAdmin = false;
          this.globals.user = null;
          this.globals.token = null;
          this.router.navigate(['/login']);
        }
        return throwError(() => error);
      })
    );
  }
}
